import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';
import { IdentityValidationInitialValidationDto } from '@core/model/identity-validation-initial-validation-dto';

@Injectable({
  providedIn: 'root',
})
export class SpecialConditionsProductService {
  private generalApiUrl: string;
  private decisionDomain: string;

  constructor(private http: HttpClient) {
    this.generalApiUrl = `${environment.apiUrl}`;
    this.decisionDomain = 'decision';
  }

  public getIsRequired(): Observable<CustomResponseDto<IdentityValidationInitialValidationDto>> {
    return this.http.get<CustomResponseDto<IdentityValidationInitialValidationDto>>(
      `${this.generalApiUrl}${this.decisionDomain}/identity/validation`
    );
  }
}
